<div class="gallery-one-wrapper">
    <div *ngFor="let item of items;let i = index" class="gallery-one-box gallery-one-box-{{i + 1}}">
        <img onError="this.src='assets/img/img-not-available.png';" [src]="item?.media?.url" 
        [alt]="item?.media?.altText ? item?.media?.altText : ''" [title]="item?.media?.title ? item?.media?.title : ''" />
        <div *ngIf="item?.buttonText" class="gallery-one-box-item">
            <h2>{{item?.largeTitle}}</h2>
            <button (click)="navigateTo(item?.url)" >{{item?.buttonText}}</button>
        </div>
    </div>
</div>